import React from 'react';
import HostPortalStore from './HostPortalStore';
import HostPortalActions from './HostPortalActions';
import {TextField} from 'form-fields';
import FAIcon from 'faIcon';
import moment from 'moment';
import classnames from 'classnames';

export default class VirtualParty extends React.Component {
	constructor(props) {
		super(props);
		moment.locale(window.jenkon.language);
	}

	submitForm() {
		if(this.refs.NewPartyTitle.isValid()) {
			let submitData = {
				EventType: this.props.selectedTheme,
				Title: this.props.NewPartyTitle
			}
			HostPortalActions.createVirtualEvent(submitData, this.props.setView.bind(this));
		} else {
			this.refs.NewPartyTitle.registerErrors();
		}
	}

	render() {
		let validationRules = {
			NewPartyTitle: {
				required: true,
				requiredMessage: this.props.resources["PWS.MyAccount.PartyTitleRequired"],
			}
		};
		let CalendarData = {
			Size: 14,
			Fill: "#333333",
			name: "calendar_check_o"
		}
		let sidenote = this.props.resources["PWS.MyAccount.VirtualPartyDateOpenDays"].replace("{0}", this.props.maxEventDays)
		return (
			<div className="animate-in">
				<div className="formSectionSubTitle">{this.props.resources["PWS.MyAccount.PartyTitle"]}</div>
				<TextField
					ref="NewPartyTitle"
					name="NewPartyTitle"
					value={this.props.NewPartyTitle}
					handleChange={HostPortalActions.changeField}
					Rules={validationRules.NewPartyTitle}
					maxLength = {100}
					label={this.props.resources["PWS.MyAccount.PartyTitlePlaceholder"]}
					classes="form-control input-bordered clearable"
				/>
				<div className="spacer12"></div>
				<div className="formSectionSubTitle">{this.props.resources["PWS.MyAccount.VirtualPartyDate"]} <span className="sidenote">({sidenote})</span></div>

				<FAIcon iconData={CalendarData}  inline={true} /> <strong>{moment().format('ll')}</strong> <span className="sidenote">({this.props.resources["PWS.MyAccount.VirtualPartyDateTodayLabel"]})</span> - {moment().add(this.props.maxEventDays, 'days').format('ll')}
				<div className="spacer12"></div>
				<div className="spacer12"></div>
				<div className="continue-button-container">
					<div className="required-field-legend"> = {this.props.resources["PWS.Globals.Required"]}</div>
					<button className={classnames("basic-submit-button", {"disabled" : this.props.NewPartyTitle.length == 0})} onClick={this.submitForm.bind(this)}>{this.props.resources["PWS.MyAccount.VirtualPartySaveButtonText"]}</button>
				</div>
			</div>

		);
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/VirtualParty.js